(() => {
    class BrandLandingPages {
        constructor(PermissionService) {
        }
    }

    angular.module("dashboard")
        .component("brandLandingPages", {
            templateUrl: "components/brand/langingpages/landingpages.501a7703.html",
            bindings: {},
            controller: ["PermissionService", BrandLandingPages ]
        })
})();
